import React, {useEffect} from 'react';
import styled from "styled-components";
import {Container, Row, Col} from "react-bootstrap";

import {
    BrowserRouter as Router,
    Switch,
    Route,
    useParams,
    useHistory, Link
} from "react-router-dom";
import {apiEndPoints} from "../../api/network/apiEndPoints";
import postReducer, {fetchPostDetail, fetchPosts} from "../../api/redux/post";
import {useDispatch, useSelector} from "react-redux";
import {HelmetProvider, Helmet} from 'react-helmet-async'
import {Loading} from "../../components/Loading";
import InnerBanner from "../../components/InnerBanner";
import ProjectList from "../../components/project/ProjectList";
import AccordionMap from "../../components/contact/AccordionMap";
import ContactForm from "../../components/contact/ContactForm";
import {fetchHome} from "../../api/redux/home";
import {fetchContact} from "../../api/redux/contact";
const MyComponent = () => {


    const dispatch = useDispatch()

    // api call
    useEffect(() => {
        let api_url = apiEndPoints.CONTACT
        dispatch(fetchContact([api_url]))
    }, [])

    let getPost = useSelector(state => state.contact)

    let banner=getPost?.posts?.[0]?.banner;
    let form=getPost?.posts?.[0]?.form;
    let meta=getPost?.posts?.[0]?.meta;

    return (
        <HelmetProvider>
            {/*dynamic title */}
            <Helmet>
                <title>{`${meta?.meta_title ? meta?.meta_title : 'Contact | UCC Infrastructure Ltd.'}`}</title>
                <meta name="description"  content={meta?.meta_desc ? meta?.meta_desc :''}/>
                <meta property="og:title" content={`${meta?.og_title ? meta?.og_title : 'Contact | UCC Infrastructure Ltd.'}`}/>
                <meta property="og:subtitle" content={`${meta?.og_title ? meta?.og_title : 'Contact | UCC Infrastructure Ltd.'}`}/>
                <meta property="og:description" content={meta?.og_desc ? meta?.og_desc :''}/>
                <meta property="og:url" content={window?.location?.href}/>
                <meta property="og:image" content={banner?.image}/>
                <meta property="og:type" content={"website"}/>
            </Helmet>

            <StyledComponent>
                <InnerBanner img={banner?.image} mimg={banner?.mobile_image} title={banner?.subtitle} text={banner?.title}/>
                <Container className={'pt-120 pb-120'}>
                    <Row>
                        <Col md={6}>
                            <AccordionMap data={getPost?.posts?.[0]?.address?.list}/>
                        </Col>
                        <Col md={{span:5,offset:1}}>
                            <ContactForm data={form}/>

                        </Col>
                    </Row>
                </Container>


            </StyledComponent>
        </HelmetProvider>

    );
};

const StyledComponent = styled.section`
  


`;

export default MyComponent;
